var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 72,
    viewBox: "0 0 1920 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1920V71.9849H1563C1563 71.9849 1454.37 71.3596 1440.5 69C1425.97 66.528 1413.5 58 1413.5 58L1384.5 40.5C1384.5 40.5 1363.99 24.8663 1347.5 22.3153C1335.09 20.3951 1321.5 22.3153 1321.5 22.3153H796C796 22.3153 773.028 21.903 758.5 25.1947C744.811 28.2965 729 37.0722 729 37.0722C729 37.0722 705.749 48.2034 690.5 54.5285C676.033 60.5293 653 68.7456 653 68.7456C635.569 72.4106 605.5 71.9849 605.5 71.9849H0V0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderimg);
export default __webpack_public_path__ + "static/media/headerimg.ae17578512b683f78d1bb63cdfaf916e.svg";
export { ForwardRef as ReactComponent };